import { render, staticRenderFns } from "./clausePage.vue?vue&type=template&id=4e9ca156&scoped=true"
import script from "./clausePage.vue?vue&type=script&lang=js"
export * from "./clausePage.vue?vue&type=script&lang=js"
import style0 from "./clausePage.vue?vue&type=style&index=0&id=4e9ca156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ca156",
  null
  
)

export default component.exports